/** Maps container-emitted paths to web URLs. */
export function containerPathToWebRoute(path: string): string {
  if (path === '/app') return webAppRoutes.app;
  if (path === '/dashboard') return webAppRoutes.dashboard;
  if (path === '/calendar') return webAppRoutes.calendar;
  if (path === '/settings') return webAppRoutes.settings;
  if (path === '/gardens') return webAppRoutes.gardens;
  if (path === '/harvest') return webAppRoutes.harvest;
  if (path === '/garden-config') return webAppRoutes.gardenConfig;
  if (path === '/plants') return webAppRoutes.plants;
  if (path === '/admin') return webAppRoutes.admin;
  if (path.startsWith('/gardens/')) return path;
  return path;
}

export function pathnameToContainerPath(pathname: string): string {
  const normalized = pathname.replace(/\/$/, '') || '/';

  if (normalized === webAppRoutes.app) {
    return '/app';
  }

  if (normalized === webAppRoutes.dashboard) {
    return '/dashboard';
  }

  if (normalized === webAppRoutes.calendar) {
    return '/calendar';
  }

  if (normalized === webAppRoutes.settings) {
    return '/settings';
  }

  return normalized;
}

export const webAppRoutes = {
  app: '/app',
  dashboard: '/dashboard',
  calendar: '/calendar',
  gardens: '/gardens',
  harvest: '/harvest',
  gardenConfig: '/garden-config',
  plants: '/plants',
  settings: '/settings',
  admin: '/admin',
  home: '/app',
  login: '/login',
  signUp: '/sign-up',
  forgotPassword: '/forgot-password',
  changePassword: '/change-password',
} as const;
